import { render } from "./choose_consumer.vue?vue&type=template&id=fa0bdf54&scoped=true"
import script from "./choose_consumer.vue?vue&type=script&lang=js"
export * from "./choose_consumer.vue?vue&type=script&lang=js"

import "./choose_consumer.vue?vue&type=style&index=0&id=fa0bdf54&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0bdf54"]])

export default __exports__